import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

/**
 * Sitewide
 */
var Sitewide = function () {

};

/**
 * Init
 */
Sitewide.prototype.init = function () {

	var self = this;

	self.$body = $('body');
	self.scrollingDisabled = 0;

	this.initEvents();
	this.initSamePageAnchorLinks();

	PubSub.subscribe('Sitewide:enableScrolling', () => self.enableScrolling());
	PubSub.subscribe('Sitewide:disableScrolling', () => self.disableScrolling());

};

/**
 * Init'ing our global events, many of which we publish
 */
Sitewide.prototype.initEvents = function () {
	//
	// Resizing (at the start)
	//
	var windowThrottled = _.throttle(
		function (e) {
			PubSub.publish('Sitewide:resize');
		},
		200, {
			trailing: false
		},
	);
	window.addEventListener('resize', windowThrottled, false);

	//
	// Resized Event (at the end)
	//
	var windowResizeDebounce = _.debounce(function (e) {
		PubSub.publish('Sitewide:resized');
	}, 200);
	window.addEventListener('resize', windowResizeDebounce, false);

	// Removed the aggressive preventDefault handler - initSamePageAnchorLinks handles smooth scrolling
	// and will skip modal triggers. This prevents blocking modal handlers.

};

/**
 * Smooth scroll to anchor elements on same page
 */
Sitewide.prototype.initSamePageAnchorLinks = function () {

	$("a[href^='#']").on("click", function(e) {

		var href = $(this).attr('href');
		
		// Don't handle tab links - let tab handlers process them. Webflow's own tabs get an
		// href="#w-tabs-..." at runtime and carry no data-tab (#90)
		if ($(this).is('[data-tab], [data-w-tab], .w-tab-link')) {
			return;
		}
		
		// Don't handle modal triggers - let modal handlers process them
		// Check for standard modal pattern
		if (href && href.indexOf('#modal-') === 0) {
			return;
		}
		
		// Check for custom modal triggers by looking for modal elements with matching data-modal-trigger attribute
		if (href) {
			var $modalWithTrigger = $('.mol-Modal[data-modal-trigger="' + href + '"]');
			var triggerWithoutHash = href.substring(1);
			var $modalWithTriggerNoHash = $('.mol-Modal[data-modal-trigger="#' + triggerWithoutHash + '"]');
			
			if ($modalWithTrigger.length > 0 || $modalWithTriggerNoHash.length > 0) {
				return; // Let modal handlers process this
			}
		}
		
		// Also check window.ModalTriggers if it exists
		if (href && window.ModalTriggers && (window.ModalTriggers[href] || window.ModalTriggers[href.substring(1)])) {
			return;
		}
		
		if (href == '#open-modal-form') return;

		// prevent page jump
		if(e) e.preventDefault();

		// make sure the anchor link is on the current page
		let link = $(this).get(0);
		if (
			link.protocol === window.location.protocol ||
			link.host === window.location.host ||
			link.pathname === window.location.pathname ||
			link.search === window.location.search
		)
		{
		
			// get scroll duration based on scroll distance
		let anchorLink = $(this).attr('href');
		
		// Skip if href is just "#" or empty (invalid selector)
		if (!anchorLink || anchorLink === '#' || anchorLink.length <= 1) {
			return;
		}
		
		// Check if the target element exists
		if (!$(anchorLink).length) {
			return;
		}
		
		let scrollDistance = Math.abs( $(anchorLink).scrollTop() - $(window).scrollTop() );
		let speed = 200;
		let duration = Math.max(0.8, scrollDistance / speed);

		// use gsap to scroll to the anchor
		gsap.to(window, {
			duration: duration,
			scrollTo: anchorLink
		});
		}

	});

};

// These scrolling functions allow scrolling to be enabled/disabled without losing scroll position
Sitewide.prototype.enableScrolling = function() {

	const self = this;

	self.scrollingDisabled--;

	// Prevent counter from going negative (safety check)
	// If counter is 0 or negative, re-enable scrolling
	if (self.scrollingDisabled <= 0) {
		self.scrollingDisabled = 0;
		// Continue to re-enable scrolling below
	} else {
		// Counter is still > 0, another modal is open, don't re-enable
		return;
	}

	let scrollY = self.$body.css("top");
	let $html = $('html');
	let scrollPosition = parseInt(scrollY || '0') * -1;

	// Remove all fixed positioning and overflow restrictions
	self.$body.css({
		position: "",
		top: "",
		width: "",
		paddingRight: "",
		overflow: ""
	});
	
	$html.css({
		paddingRight: "",
		overflow: ""
	});

	// Use requestAnimationFrame to ensure styles are applied before scrolling
	requestAnimationFrame(function() {
		// Restore scroll position
		window.scrollTo(0, scrollPosition);
	});

}

Sitewide.prototype.disableScrolling = function() {

	const self = this;

	self.scrollingDisabled++;

	if (self.scrollingDisabled != 1) return;

	// Calculate scrollbar width to prevent layout shift
	// Create a temporary div to measure scrollbar width more accurately
	let scrollbarWidth = 0;
	let scrollDiv = document.createElement('div');
	scrollDiv.style.cssText = 'width:100px;height:100px;overflow:scroll;position:absolute;top:-9999px;';
	document.body.appendChild(scrollDiv);
	scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	document.body.removeChild(scrollDiv);
	
	// Fallback if measurement fails
	if (scrollbarWidth === 0) {
		scrollbarWidth = window.innerWidth - document.documentElement.clientWidth || 17;
	}
	
	let top = `-${window.scrollY}px`;
	let $html = $('html');

	// Apply padding to both html and body to prevent shift
	self.$body.css({
		position: "fixed",
		top: top,
		width: "100%",
		paddingRight: scrollbarWidth + 'px',
		overflow: "hidden"
	});
	
	// Also apply to html to ensure no shift
	$html.css({
		paddingRight: scrollbarWidth + 'px',
		overflow: "hidden"
	});

}

export default Sitewide;